import { render, staticRenderFns } from "./ButtonsLoginAndCreateAccount.vue?vue&type=template&id=38ad1dcf&lang=pug"
import script from "./ButtonsLoginAndCreateAccount.vue?vue&type=script&lang=js"
export * from "./ButtonsLoginAndCreateAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports